export const GMAP_ASYNC_BUNDLE_KEY = "gmaps";
export const PLACE_ASYNC_BUNDLE_KEY = "places";

export const GMAP_API_KEY = "AIzaSyDRSSlxqRXArawbMzXgjuq34JYMPCm6dP0";
export const GMAP_MAP_ID = "c74e286c605f85174bbb053c";

// `marker` lib = AdvancedMarkerElement; `v=weekly` ensures AdvancedMarker + colorScheme.
// NOTE: deliberately NOT using `loading=async` — this URL is shared (same bundle key)
// with Searchaddress, which accesses `google.maps.places` synchronously on script
// load. Classic load keeps that working; AdvancedMarker only needs the marker lib.
export const GMAP_SCRIPT_URL = `https://maps.googleapis.com/maps/api/js?key=${GMAP_API_KEY}&libraries=marker,places,geometry&v=weekly`;

// Store locator map tuning (refactor 2026-07).
export const GMAP_DEFAULT_RADIUS_MILES = 50;
export const GMAP_RADIUS_CAP_MILES = 300;
// Zoom-out lock: prevents seeing the whole dataset at a glance. Higher = more
// restricted. 6 keeps ~a few states in view (still fits a 300 mi radius) without
// exposing the whole US. Try 7 for tighter, 5 for looser.
export const GMAP_MIN_ZOOM = 7;
// Distance select options (miles) — mirrors src/components/Searchaddress markup.
export const GMAP_DISTANCE_OPTIONS = [15, 50, 200];

// Nashville studio — used as the map center fallback (geolocation deny / empty data).
// Repurposed from the old US-centroid value (store locator refactor 2026-07).
export const GMAP_USA_CENTER = {
  lat: 35.9618128,
  lng: -86.8215832,
};

// North America pan bounds (US + Canada; soft — strictBounds:false in MapEngine).
export const GMAP_USA_BOUNDS = {
  north: 72, // Point Barrow, Alaska
  south: 17, // Puerto Rico (Isla Caja de Muertos)
  east: -52, // Cape Spear, Newfoundland (easternmost Canada; still covers Puerto Rico ~-65)
  west: -179, // Alaska / Aleutian Islands
};
